export default defineNuxtPlugin(() => {
  if (!import.meta.client) return
  if (!document.getElementById('hs-chat-script')) {
    const script = document.createElement('script')
    script.src = '//js-na1.hs-scripts.com/7558905.js' // your HubSpot portal ID
    script.async = true
    script.defer = true
    script.id = 'hs-chat-script'
    // NOTE: Not actually loading script here, because marketing is loading it
    // But if for some reason, we need to load it on our side in the future
    // just uncomment this line
    // document.head.appendChild(script)
  }
})
